import { GoogleDeviceOrganizationalUnitSource, GoogleDeviceOUOperator } from "../../../../../../models/CoreGoogleDeviceExportModels";

export const OrganizationalUnitPathSources: GoogleDeviceOrganizationalUnitSource[] = [
    GoogleDeviceOrganizationalUnitSource.RecentUser,
    GoogleDeviceOrganizationalUnitSource.SchoolAdminUser,
    GoogleDeviceOrganizationalUnitSource.ValueBuilder,
    GoogleDeviceOrganizationalUnitSource.None
]

export const DeviceOUOperator: GoogleDeviceOUOperator[] =  [
    GoogleDeviceOUOperator.Equals,
    GoogleDeviceOUOperator.StartsWith,
]
